// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"impressum-module--wrapper--FuwIJ","SectionTitle":"impressum-module--SectionTitle--3zIDZ"};